"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function isDSTActive() {
  const january = new Date();
  january.setMonth(0);
  const currentMonth = new Date();
  return Boolean(currentMonth.getTimezoneOffset() - january.getTimezoneOffset());
}

function concatMinutes(hours, minutes) {
  const twelveHourClockHours = Number(hours) === 0 ? 12 : hours;
  return `${twelveHourClockHours}:${minutes < 10 ? `0${minutes}` : minutes}`;
}

function concatAmAndPm(date) {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  if (hours === 12) {
    return `${concatMinutes(hours, minutes)} p.m.`;
  }

  if (hours === 0) {
    return `${concatMinutes(12, minutes)} a.m.`;
  }

  return hours > 12 ? `${concatMinutes(hours % 12, minutes)} p.m.` : `${concatMinutes(hours, minutes)} a.m.`;
}

function toTimezone(date, timezone) {
  return new Date(date).toLocaleString('en-us', timezone ? {
    timeZone: timezone
  } : {});
}

function getClientLocation() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function getClientTimezoneReport() {
  const offset = new Date().getTimezoneOffset();
  return {
    clientTimezone: offset === 0 ? offset : -1 * offset,
    isDST: isDSTActive()
  };
}

function addHours(date, hours) {
  if (!hours || Number.isNaN(hours) || !Number.isFinite(hours)) {
    return date;
  }

  const d = new Date();
  d.setTime(date.getTime() + hours * 60 * 60 * 1000);
  return d;
}

var _default = {
  isDSTActive,
  concatMinutes,
  concatAmAndPm,
  toTimezone,
  getClientLocation,
  getClientTimezoneReport,
  addHours
};
exports.default = _default;